import React from 'react';
import ButtonRow from '../../../Elements/ButtonRow';
import ShownPanelsEnum from '../../../Enums/ShownPanelsEnum';
import CountryService from '../../../Services/CountryService';
import CountryItemForAdmin from '../../../Domain/CountryItemForAdmin';
import CountrySearchParams from './CountrySearchParams';
import GeneralEditWizzardBase from '../../../Elements/GeneralEditWizzard/GeneralEditWizzardBaseFigma';
import CountryWindowDescription from './CountryWindowDescription';
import CrudTypesEnum from '../../../Enums/CrudTypesEnum';
import ButtonColorsEnum from '../../../Enums/ButtonColorsEnum';
import TabOfDataTable from '../../../Elements/DataTable/TabOfDataTable';

export default class CountryAdmin extends React.Component {
  static defaultProps = {};

  constructor(props) {
    super(props);

    this.state = {
      searchItem: new CountrySearchParams(),
      selectedCountry: null,
      shownPanel: ShownPanelsEnum.None,
    };
    this.showPanel = this.showPanel.bind(this);
    this.startSearch = this.startSearch.bind(this);
    CountryItemForAdmin.editFunction = this.editFunction.bind(this);
    this.panelOnClose = this.panelOnClose.bind(this);
  }

  showPanel(panelId) {
    if (panelId === ShownPanelsEnum.Refresh) {
      panelId = ShownPanelsEnum.None;
    }
    panelId = panelId === this.state.shownPanel ? ShownPanelsEnum.None : panelId;
    this.setState({ shownPanel: panelId });
  }

  renderButtonsAndPanels() {
    return (
      <>
        <ButtonRow
          tooltips={['Create']}
          keys={[ShownPanelsEnum.AddNewItem]}
          colors={[ButtonColorsEnum.Primary]}
          roles={['Admin']}
          icons={['fa-solid fa-plus-circle']}
          value={this.state.shownPanel}
          onClick={this.showPanel}
        />
        {this.renderPanels()}
      </>
    );
  }

  startSearch(searchItem) {
    this.setState({ searchItem });
  }

  editFunction(id, country) {
    this.setState({
      shownPanel: ShownPanelsEnum.EditCountry,
      selectedCountry: country,
    });
  }

  renderPanels() {
    if (this.state.shownPanel === ShownPanelsEnum.EditCountry) {
      return this.getEditPanel(this.state.selectedCountry);
    }

    if (this.state.shownPanel === ShownPanelsEnum.AddNewItem) {
      return this.getCreatePanel();
    }
  }

  refresh() {
    this.setState({ searchItem: { ...this.state.searchItem } });
  }

  panelOnClose() {
    this.setState({ shownPanel: ShownPanelsEnum.None });
    this.refresh();
  }

  getEditPanel(country) {
    return (
      <GeneralEditWizzardBase
        crudType={CrudTypesEnum.Update}
        editedItem={country}
        clickOnCancel={this.panelOnClose}
        clickOnSave={this.panelOnClose}
        windowDescription={CountryWindowDescription}
        errorCode='CA93'
      />
    );
  }

  getCreatePanel() {
    const tempEdited = new CountryItemForAdmin(); // empty ctor → CountryId === '' (routes UpsertCountry to POST)
    return (
      <GeneralEditWizzardBase
        crudType={CrudTypesEnum.Create}
        editedItem={tempEdited}
        clickOnCancel={this.panelOnClose}
        clickOnSave={this.panelOnClose}
        windowDescription={CountryWindowDescription}
        errorCode='CA103'
      />
    );
  }

  render() {
    return (
      <div className='contentwrapper'>
        {this.renderButtonsAndPanels()}
        <TabOfDataTable
          clickOnStartSearch={this.startSearch}
          searchParamsType={CountrySearchParams}
          searchItem={this.state.searchItem}
          showSearchStrip={true}
          serviceFunction={CountryService.GetAllCountryBySearching}
          convertDBItemsFunction={CountryService.ConvertAllDBCountry}
          shownPanel={this.state.shownPanel}
          type={CountryItemForAdmin}
          popupEnabled={true}
          singleSearchLine={true}
          singleSearchLinePlaceholder='Search in name, code...'
          errorCode='CA138'
        />
      </div>
    );
  }
}
